import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { NeworderbankPage } from './neworderbank/neworderbank';
import { PreorderbankPage } from './preorderbank/preorderbank';
import { ReportorderbankPage } from './reportorderbank/reportorderbank';
import { GN } from '../../../gn';
import { CurrentfuturebanknalogPage } from './reportorderbank/currentfuturebanknalog';
import { HistoryviewnalogbankPage } from './reportorderbank/historyviewnalogbank';
import { RoutemomentkokpitPage } from '../routemomentkokpit/routemomentkokpit';
import { DIC } from '../../dic';
import * as moment from 'moment';


/**
 * Generated class for the RoutebankPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-routebank',
  templateUrl: 'routebank.html',
})
export class RoutebankPage {
  selectedroutePage: any
  SelectedMenuBank = 1
  Roletna: boolean = false

  routingTab: string = 'vehicles'
  loadingData: boolean = true
  loadingDataDrivers: boolean = true
  cntvehavailable = 0
  cntvehbusy = 0
  cntveh = 0

  cntdravailable = 0
  cntdrbusy = 0
  cntdr = 0

  arrV1 = []
  arrV2 = []
  arrD1 = []
  arrD2 = []


  cntnalog = 0
  cnttekovni = 0
  cntidni = 0
  cntzavrseni = 0

  arrN1 = []
  arrN2 = []
  arrN3 = []

  routeVehicles = []
  routeDrivers = []

  routeNalog = []
  loadingDataNalog: boolean = true



  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC) {
    this.doSelectMeu(1)
    var _that = this
    this.gn.routeBankFunction = function () {
      _that.doSelectMeu(1)
    }
  }

  public doSelectMeu(_idx) {
    this.SelectedMenuBank = _idx
    if (_idx == 1) {
      this.selectedroutePage = NeworderbankPage
    }
    if (_idx == 2) {
      this.selectedroutePage = PreorderbankPage
    }
    if (_idx == 3) {
      this.selectedroutePage = CurrentfuturebanknalogPage
    }
    if (_idx == 4) {
      this.selectedroutePage = HistoryviewnalogbankPage
    }
    if (_idx == 5) {
      this.selectedroutePage = RoutemomentkokpitPage
    }
  }
  ionViewDidLoad() {
    if (this.gn.user.driverid + '' != '-1') {
      this.SelectedMenuBank = 3
      this.selectedroutePage = ReportorderbankPage
    }
    // this.getVehiclesforRoutes()
    // this.loadRoletna()
    console.log('ionViewDidLoad RoutebankPage');
  }

  loadRoletna() {
    console.log(this.Roletna, 'daj da vidam roletna')
    this.getVehiclesforRoutes()

  }


  changeeeee(proba) {
    // console.log(this.routingTab, 'daj da vidam routing tab')
    if (proba == true) {
      if (this.routingTab == 'vehicles') {
        this.getVehiclesforRoutes()
      }
      if (this.routingTab == 'employees') {
        this.getDriversforRoutes()
      }
      if (this.routingTab == 'viewroutes') {
        this.getNalogforRoutes()
      }
    }

  }







  getVehiclesforRoutes() {
    console.log('console.log tuka')
    this.routeVehicles = []
    this.cntvehavailable = 0
    this.cntvehbusy = 0
    this.cntveh = 0
    this.arrV1 = []
    this.arrV2 = []
    var _that = this
    this.gn._Post('/api/gn/nlbcurrentviewvehicles', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      // _that.routeVehicles = _data

      _that.cntveh = _data.length;
      for (let i = 0; i < _data.length; i++) {
        if (_data[i].info.length > 0) {
          _data[i].info.split('#')
          _data[i].nalogid = _data[i].info.split('#')[1]
          _data[i].startdate = _data[i].info.split('#')[0]
          _data[i].startdate = moment(_data[i].startdate).format('DD-MM-YYYY HH:mm')
          _data[i].distance = parseInt(_data[i].info.split('#')[2]).toFixed(0)
          _data[i].time = _that.sec2str2(_data[i].info.split('#')[3])
          _data[i].driver = (_data[i].info.split('#')[4]).substring(0, _data[i].info.split('#')[4].length - 2)
        } else {
          _data[i].info = '/'
          _data[i].nalogid = '/'
          _data[i].startdate = '/'
          _data[i].startdate = '/'
          _data[i].distance = '/'
          _data[i].time = '/'
          _data[i].driver = '/'
          _data[i].poivisits = '/'
        }
        _data[i].cntfromtocorrect = _data[i].cntfromtocorrect + '/' + _data[i].poivisits.split('/')[0]


        if (_data[i].cnt > 0) {
          _that.cntvehbusy++;
          _that.arrV1.push(_data[i])
        }
        else {
          _that.cntvehavailable++;
          _that.arrV2.push(_data[i])
        }
      }
      _that.routeVehicles = [{ id: 1, array: _that.arrV1, name: _that.dic.l["currentroutebusy"], icon: "ios-remove-circle-outline", cnt: _that.cntvehbusy, color: "#f53d3d" },
      { id: 2, array: _that.arrV2, name: _that.dic.l["currentrouteavailable"], icon: "ios-checkmark-circle-outline", cnt: _that.cntvehavailable, color: "#54d469" }]
      //debugger
      _that.loadingData = false
    })
  }

  getDriversforRoutes() {
    this.cntdravailable = 0
    this.cntdrbusy = 0
    this.cntdr = 0

    this.routeDrivers = []
    this.arrD1 = []
    this.arrD2 = []
    var _that = this

    this.gn._Post('/api/gn/nlbcurrentviewdrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      // console.log(_data, 'daj da vidam data')

      _that.cntdr = _data.length;
      for (let i = 0; i < _data.length; i++) {
        if (_data[i].info.length > 0) {
          _data[i].info.split('#')
          _data[i].nalogid = _data[i].info.split('#')[1]
          _data[i].startdate = _data[i].info.split('#')[0]
          _data[i].startdate = moment(_data[i].startdate).format('DD-MM-YYYY HH:mm')
          _data[i].distance = parseInt(_data[i].info.split('#')[2]).toFixed(0)
          _data[i].time = _that.sec2str2(_data[i].info.split('#')[3])
          var tmpcodrivers = (_data[i].info.split('#')[4]).substring(0, _data[i].info.split('#')[4].length - 2)
          _data[i].codrivers = tmpcodrivers == '' ? '/' : tmpcodrivers
        } else {
          _data[i].info = '/'
          _data[i].nalogid = '/'
          _data[i].startdate = '/'
          _data[i].startdate = '/'
          _data[i].distance = '/'
          _data[i].time = '/'
          _data[i].codrivers = '/'
          _data[i].poivisits = '/'
        }
        _data[i].cntfromtocorrect = _data[i].cntfromtocorrect + '/' + _data[i].poivisits.split('/')[0]


        if (_data[i].cnt > 0) {
          _that.cntdrbusy++;
          _that.arrD1.push(_data[i])
        }
        else {
          _that.cntdravailable++;
          _that.arrD2.push(_data[i])
        }
      }
      _that.routeDrivers = [{ id: 1, array: _that.arrD1, name: _that.dic.l["currentroutebusy"], icon: "ios-remove-circle-outline", cnt: _that.cntdrbusy, color: "#f53d3d" },
      { id: 2, array: _that.arrD2, name: _that.dic.l["currentrouteavailable"], icon: "ios-checkmark-circle-outline", cnt: _that.cntdravailable, color: "#54d469" }]

      _that.loadingDataDrivers = false
      // console.log(_that.routeDrivers, '_that.routeDrivers')
    })



  }

  // routingSegments() {
  //   console.log(this.routingTab, 'roiting tab')
  //   if (this.routingTab == 'vehicles') {
  //     this.getVehiclesforRoutes()
  //   }
  //   if (this.routingTab == 'employees') {
  //     this.getDriversforRoutes()
  //   }
  //   if (this.routingTab == 'viewroutes') {
  //     this.getNalogforRoutes()
  //   }

  // }

  // proba(_proba) {
  //   console.log(_proba, 'probaaaa')
  // }


  changeSegments(name) {
    console.log(this.Roletna, 'daj da vidam this roletna')
    console.log('name', name)
    if (name == 'vehicles') {
      this.getVehiclesforRoutes()
    }
    if (name == 'employees') {
      this.getDriversforRoutes()
    }
    if (name == 'viewroutes') {
      this.getNalogforRoutes()
    }
  }



  getNalogforRoutes() {
    this.routeNalog = []
    this.cntnalog = 0
    this.cnttekovni = 0
    this.cntidni = 0
    this.cntzavrseni = 0
    this.arrN1 = []
    this.arrN2 = []
    this.arrN3 = []
    var _that = this
    this.gn._Post('/api/gn/nlbcurrentviewroutes', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      // console.log(_data, 'daj da vidime data')
      _that.cntnalog = _data.length
      for (let i = 0; i < _data.length; i++) {
        _data[i].startdate = moment(_data[i].startdate).format('DD-MM-YYYY HH:mm:ss')
        var tmpcodrivers = _data[i].ekipa.substring(0, _data[i].ekipa.length - 2)

        // var tmpcodrivers = (_data[i].ekipa.split(',')).substring(0, _data[i].ekipa.length - 2)
        _data[i].ekipa = tmpcodrivers
        if (parseInt(_data[i].routestatus + '') == 0) {
          _that.cnttekovni++
          _that.arrN1.push(_data[i])
        }
        if (parseInt(_data[i].routestatus + '') == 1) {
          _that.cntidni++
          _that.arrN2.push(_data[i])
        }
        if (parseInt(_data[i].routestatus + '') == 2) {
          _that.cntzavrseni++
          _that.arrN3.push(_data[i])
        }
        _data[i].cntfromtocorrect = _data[i].cntfromtocorrect + '/' + _data[i].poivisits.split('/')[0]


      }

      _that.routeNalog = [
        { id: 1, array: _that.arrN1, name: _that.dic.l["tekovni"], cnt: _that.cnttekovni, icon: "ios-checkmark-circle-outline", color: "#54d469" },
        { id: 2, array: _that.arrN2, name: _that.dic.l["nezapocnati"], cnt: _that.cntidni, icon: "ios-redo", color: "#488aff" },
        { id: 3, array: _that.arrN3, name: _that.dic.l["zavrseni"], cnt: _that.cntzavrseni, icon: "ios-remove-circle-outline", color: "#f53d3d" }
      ]


      _that.loadingDataNalog = false

      // console.log(_that.routeNalog, 'routeNalog')

    })

  }



  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/routebank.ts